<mat-progress-bar 
    [appProgressBarColor]="color.color"
    [gradiente]="color.gradiente"
    mode="determinate" 
    [value]="porcentage">
</mat-progress-bar>
<div class="nivel">
    <div class="baja">Baja</div>
    <div class="alta">Alta</div>
</div>